import api from './index'

interface SearchParams {
  query: string
  projectKey?: string
  searchTypes: string[]
  includeAttachments?: boolean
  filters: {
    userId?: string
    dateFrom?: string
    dateTo?: string
    fileTypes?: string[]
    issueStatus?: string
    activityType?: string
  }
  pagination: {
    page: number
    limit: number
  }
}

interface SearchResult {
  type: 'issue' | 'activity' | 'comment' | 'attachment' | 'worklog'
  id: string
  title: string
  description: string
  projectKey: string
  projectName: string
  user: {
    id: string
    name: string
    email: string
    avatar: string | null
  }
  createdAt: string
  relevanceScore: number
  metadata: {
    issueKey?: string
    issueStatus?: string
    activityType?: string
    issueTitle?: string
    issueId?: string
    issueDeleted?: boolean
    issueArchived?: boolean
    field?: string
    oldValue?: string
    newValue?: string
    originalName?: string
    fileSize?: number
    mimeType?: string
    filepath?: string
    parentIssue?: string
    workLogType?: 'project' | 'global'
    workLogStatus?: string
    workLogDateRange?: string
  }
}

interface SearchResponse {
  success: boolean
  data: {
    results: SearchResult[]
    pagination: {
      page: number
      limit: number
      totalCount: number
      totalPages: number
    }
    query: string
    projectKey?: string
    searchTypes: string[]
    filters: any
  }
}

interface ProjectActivitiesParams {
  projectKey: string
  search?: string
  userId?: string
  activityType?: string
  dateFrom?: string
  dateTo?: string
  page?: number
  limit?: number
}

interface ProjectActivitiesResponse {
  success: boolean
  data: {
    activities: any[]
    pagination: {
      page: number
      limit: number
      totalCount: number
      totalPages: number
    }
  }
}

// 統一搜尋 API
export const searchUnified = async (params: SearchParams): Promise<SearchResponse> => {
  const response = await api.post('/search', params)
  return response.data
}

// 專案活動搜尋 API
export const searchProjectActivities = async (params: ProjectActivitiesParams): Promise<ProjectActivitiesResponse> => {
  const { projectKey, ...queryParams } = params
  
  const searchParams = new URLSearchParams()
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })
  
  const response = await api.get(`/search/projects/${projectKey}/activities?${searchParams.toString()}`)
  return response.data
}

export type { SearchParams, SearchResult, SearchResponse, ProjectActivitiesParams, ProjectActivitiesResponse }